module.exports = __webpack_public_path__ + "img/034-035.ea314d4e.jpg";